import ImageDetails from "./ImageDetailsContainer";
export default ImageDetails;
